// extracted by mini-css-extract-plugin
export default {"list":"UnloadingsList_list__BuYhS","centered":"UnloadingsList_centered__EeAwG","message":"UnloadingsList_message__JR8Id"};